module.exports = "<svg class=\"Svg Svg--tonkvisl\" viewBox=\"0 0 150 150\"><path d=\"M75,0 C33.58125,0 0,33.58125 0,75 C0,116.41875 33.58125,150 75,150 C116.41875,150 150,116.41875 150,75 C150,33.58125 116.41875,0 75,0 L75,0 Z M96.496875,109.753125 L65.625,78.88125 L65.625,37.5 L84.375,37.5 L84.375,71.11875 L109.753125,96.496875 L96.496875,109.753125 L96.496875,109.753125 Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ../~/svg-inline-loader!../images/schedule.svg
// module id = 547
// module chunks = 0